import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AmplitudeService } from '../../services/amplitude.service';
import { AuthService } from '../../services/auth.service';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  standalone: false,
})
export class SignupComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  email: string = '';
  name: string = '';
  code: string = '';
  password: string = '';
  confirmPassword: string = '';
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;

  constructor(
    private snackBar: SnackbarService,
    private authService: AuthService,
    private router: Router,
    private amplitudeService: AmplitudeService,
  ) {}

  ngOnInit(): void {}

  signup(): void {
    if (this.password !== this.confirmPassword) {
      this.snackBar.warning('La contraseña y la confirmación no coinciden.');
      return;
    }

    const data = {
      email: this.email,
      name: this.name,
      code: this.code,
      password: this.password,
    };

    this.blockUI.start();
    this.authService
      .register(data)
      .then(() => {
        this.blockUI.stop();
        this.snackBar.success('Te has registrado correctamente');
        this.router.navigate(['/login']);
        this.amplitudeService.logEvent('SignUp', { result: 'success' });
      })
      .catch((error) => {
        this.blockUI.stop();
        this.snackBar.error(error.message);
      });
  }

  showLogin() {
    this.router.navigate(['/login']);
  }
}
